export default __webpack_public_path__ + "static/krasnoyarsk-2-251edd4bf41bec328f8a2432cd27b481.png";